import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const UpdateUserRoleRequestDtoSchema = z.object({
  id: z.number(),
  roleId: z.number(),
});

const UpdateUserRoleResponseDtoSchema = UserDtoSchema;

export type UpdateUserRoleRequestDto = z.infer<
  typeof UpdateUserRoleRequestDtoSchema
>;
export type UpdateUserRoleResponseDto = z.infer<
  typeof UpdateUserRoleResponseDtoSchema
>;

export const updateUserRole = (
  dto: UpdateUserRoleRequestDto,
  config?: AxiosRequestConfig<UpdateUserRoleRequestDto>
) => {
  const { id, ...data } = UpdateUserRoleRequestDtoSchema.parse(dto);
  return api
    .patch(`/users/${id}/role`, data, config)
    .then(responseContract(UpdateUserRoleResponseDtoSchema));
};
